import { useCallback } from "react";
import { useNavigate } from "react-router";
import {
  isPublicPageDisabled,
  publicRoutes,
} from "app/router/public/routes";
import type { PublicPage } from "app/router/public/types";
import { scrollToTop } from "shared/lib/scroll";

export function usePageNavigation() {
  const navigate = useNavigate();

  return useCallback(
    (page: PublicPage) => {
      const targetPage = isPublicPageDisabled(page) ? "home" : page;

      navigate(publicRoutes[targetPage].path);
      scrollToTop();
    },
    [navigate],
  );
}
